export default __webpack_public_path__ + "static/media/WrongBtn.ecd29118.mp3";